<div class="audit-dashboard">
  <div class="header-row">
    <h2 class="title">Audit events</h2>
    <button
      nz-button
      nzType="default"
      nzDanger
      [nzLoading]="cleanupLoading()"
      (click)="runCleanup()"
    >
      <span nz-icon nzType="delete"></span>
      Cleanup (older than {{ cleanupDays }} days)
    </button>
  </div>

  <nz-divider nzText="Filters"></nz-divider>

  <div class="filters">
    <div class="filter-group">
      <label>Action</label>
      <input
        nz-input
        placeholder="e.g. patient.added, survey.created"
        [(ngModel)]="filterAction"
      />
    </div>
    <div class="filter-group">
      <label>Origin</label>
      <nz-select
        [(ngModel)]="filterOrigin"
        nzPlaceHolder="All"
        class="filter-select"
      >
        @for (opt of originOptions; track opt.value) {
          <nz-option [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
        }
      </nz-select>
    </div>
    <div class="filter-group">
      <label>Entity type</label>
      <input
        nz-input
        placeholder="e.g. patient, survey, visit"
        [(ngModel)]="filterEntityType"
      />
    </div>
    <div class="filter-group">
      <label>Entity ID</label>
      <input nz-input placeholder="UUID" [(ngModel)]="filterEntityId" />
    </div>
    <div class="filter-group">
      <label>Actor ID</label>
      <input nz-input placeholder="UUID" [(ngModel)]="filterActorId" />
    </div>
    <div class="filter-group">
      <label>From date</label>
      <nz-date-picker
        [(ngModel)]="filterFrom"
        nzFormat="yyyy-MM-dd"
        placeholder="Start date"
        class="filter-date"
      ></nz-date-picker>
    </div>
    <div class="filter-group">
      <label>To date</label>
      <nz-date-picker
        [(ngModel)]="filterTo"
        nzFormat="yyyy-MM-dd"
        placeholder="End date"
        class="filter-date"
      ></nz-date-picker>
    </div>
    <div class="filter-actions">
      <button nz-button nzType="primary" (click)="applyFilters()">
        <span nz-icon nzType="search"></span>
        Apply
      </button>
      <button nz-button (click)="resetFilters()">Reset</button>
    </div>
  </div>

  <nz-divider></nz-divider>

  <nz-table
    #auditTable
    [nzData]="events()"
    [nzLoading]="loading()"
    [nzTotal]="total()"
    [nzPageIndex]="pageIndex()"
    [nzPageSize]="pageSize()"
    [nzFrontPagination]="false"
    [nzShowSizeChanger]="true"
    [nzPageSizeOptions]="[20, 50, 100, 200, 500]"
    (nzQueryParams)="onQueryParamsChange($event)"
  >
    <thead>
      <tr>
        <th nzWidth="80px">Time</th>
        <th nzWidth="140px">Action</th>
        <th nzWidth="80px">Origin</th>
        <th nzWidth="100px">Actor type</th>
        <th>Actor ID</th>
        <th nzWidth="100px">Entity type</th>
        <th>Entity ID</th>
        <th>Extra</th>
      </tr>
    </thead>
    <tbody>
      @for (row of auditTable.data; track row.id) {
        <tr>
          <td>{{ row.created_at | date : 'short' }}</td>
          <td>{{ row.action }}</td>
          <td>{{ row.origin }}</td>
          <td>{{ row.actor_type ?? '—' }}</td>
          <td class="mono">{{ row.actor_id ?? '—' }}</td>
          <td>{{ row.entity_type ?? '—' }}</td>
          <td class="mono">{{ row.entity_id ?? '—' }}</td>
          <td class="extra-cell">{{ formatExtra(row.extra) }}</td>
        </tr>
      } @empty {
        <tr>
          <td colspan="8" class="empty-cell">No audit events match the filters.</td>
        </tr>
      }
    </tbody>
  </nz-table>
</div>
